import React, { Component } from "react";
const loader = require("../../images/loading3.gif");
class Loader extends Component {
  render() {
    return (
      <div id="new-loader">
        <img src={loader} alt="loading..." />
      </div>
    );
  }
}
export default Loader;
